//auth 2.0
/**
 * Build styles
 */
import _CodeMirrorEditor from "codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/eclipse.css";
import "codemirror/theme/dracula.css";
import "codemirror/mode/python/python";
import "codemirror/mode/css/css";
import "codemirror/mode/dockerfile/dockerfile";
import "codemirror/mode/htmlmixed/htmlmixed";
import "codemirror/mode/markdown/markdown";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/php/php";
import "codemirror/mode/r/r";
import "codemirror/mode/sass/sass";
import "codemirror/mode/sql/sql";
import "codemirror/mode/swift/swift";
import "codemirror/mode/vue/vue";
import "codemirror/mode/xml/xml";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/html-hint";
import "codemirror/addon/hint/css-hint";
import "codemirror/addon/hint/javascript-hint";
import "codemirror/addon/hint/xml-hint";
import "codemirror/addon/hint/sql-hint";
import "codemirror/addon/hint/anyword-hint";
import "codemirror/addon/edit/closebrackets";
import "./index.css";
import { makeElement } from "../../../../utils/utils";

const EDITOR_JS_CODE_BLOCK_RECENT_LANGUAGE = "EditorJS_CodeBlock_RecentLanguage";
const EDITOR_JS_CODE_BLOCK_RECENT_THEME = "EditorJS_CodeBlock_RecentTheme";
const CODE_MIRROR_EDITOR = window.CodeMirror || _CodeMirrorEditor;
const EXCLUDED_INTELLI_SENSE_TRIGGER_KEYS = {
  8: "backspace",
  9: "tab",
  13: "enter",
  16: "shift",
  17: "ctrl",
  18: "alt",
  19: "pause",
  20: "capslock",
  27: "escape",
  33: "pageup",
  34: "pagedown",
  35: "end",
  36: "home",
  37: "left",
  38: "up",
  39: "right",
  40: "down",
  45: "insert",
  46: "delete",
  91: "left window key",
  92: "right window key",
  93: "select",
  107: "add",
  109: "subtract",
  110: "decimal point",
  111: "divide",
  112: "f1",
  113: "f2",
  114: "f3",
  115: "f4",
  116: "f5",
  117: "f6",
  118: "f7",
  119: "f8",
  120: "f9",
  121: "f10",
  122: "f11",
  123: "f12",
  144: "numlock",
  145: "scrolllock",
  186: "semicolon",
  187: "equalsign",
  188: "comma",
  189: "dash",
  190: "period",
  191: "slash",
  192: "graveaccent",
  220: "backslash",
  222: "quote",
};

export const SUPPORT_LANGUAGES = {
  Python: "Python",
  CSS: "CSS",
  HTML: "htmlmixed",
  MarkDown: "MarkDown",
  Javascript: "Javascript",
  PHP: "PHP",
  R: "R",
  SASS: "sass",
  SQL: "sql",
  Swift: "swift",
  Vue: "vue",
  XML: "xmls",
  Java: "text/x-java",
  C: "text/x-csrc",
  "C++": "text/x-c++src",
  "C#": "text/x-csharp",
};

const THEMES = {
  Light: "Light",
  Dark: "Dark",
};

/**
 * Code Tool for the Editor.js allows to include code examples in your articles.
 */ export default class CodeMirrorTool {
  /**
   * Icon and title for displaying at the Toolbox
   *
   * @return {{icon: string, title: string}}
   */
  static get toolbox() {
    return {
      icon: `<svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 0.5C3.93983 0.5 3.47078 0.604857 3.09181 0.825923C2.70636 1.05077 2.45386 1.37271 2.29309 1.73443C1.99943 2.39517 1.99973 3.23604 1.99999 3.93891L2 4C2 4.78521 1.99087 5.41443 1.79309 5.85943C1.70386 6.06021 1.58136 6.20702 1.40431 6.3103C1.22078 6.41736 0.939834 6.5 0.5 6.5C0.223858 6.5 0 6.72386 0 7C0 7.27614 0.223858 7.5 0.5 7.5C0.939834 7.5 1.22078 7.58264 1.40431 7.6897C1.58136 7.79298 1.70386 7.93979 1.79309 8.14057C1.99087 8.58557 2 9.2148 2 10L1.99999 10.0611C1.99973 10.764 1.99943 11.6048 2.29309 12.2656C2.45386 12.6273 2.70636 12.9492 3.09181 13.1741C3.47078 13.3951 3.93983 13.5 4.5 13.5C4.77614 13.5 5 13.2761 5 13C5 12.7239 4.77614 12.5 4.5 12.5C4.06017 12.5 3.77922 12.4174 3.59569 12.3103C3.41864 12.207 3.29614 12.0602 3.20691 11.8594C3.00913 11.4144 3 10.7852 3 10L3.00001 9.9389C3.00027 9.23604 3.00057 8.39517 2.70691 7.73443C2.58396 7.45781 2.40737 7.20446 2.1587 7C2.40737 6.79554 2.58396 6.54219 2.70691 6.26557C3.00057 5.60483 3.00027 4.76396 3.00001 4.0611V4.0611L3 4C3 3.21479 3.00913 2.58557 3.20691 2.14057C3.29614 1.93979 3.41864 1.79298 3.59569 1.6897C3.77922 1.58264 4.06017 1.5 4.5 1.5C4.77614 1.5 5 1.27614 5 1C5 0.723858 4.77614 0.5 4.5 0.5ZM11.5 0.5C11.2239 0.5 11 0.723858 11 1C11 1.27614 11.2239 1.5 11.5 1.5C11.9398 1.5 12.2208 1.58264 12.4043 1.6897C12.5814 1.79298 12.7039 1.93979 12.7931 2.14057C12.9909 2.58557 13 3.21479 13 4L13 4.06109C12.9997 4.76396 12.9994 5.60483 13.2931 6.26557C13.416 6.54219 13.5926 6.79554 13.8413 7C13.5926 7.20446 13.416 7.45781 13.2931 7.73443C12.9994 8.39517 12.9997 9.23604 13 9.9389L13 10C13 10.7852 12.9909 11.4144 12.7931 11.8594C12.7039 12.0602 12.5814 12.207 12.4043 12.3103C12.2208 12.4174 11.9398 12.5 11.5 12.5C11.2239 12.5 11 12.7239 11 13C11 13.2761 11.2239 13.5 11.5 13.5C12.0602 13.5 12.5292 13.3951 12.9082 13.1741C13.2936 12.9492 13.5461 12.6273 13.7069 12.2656C14.0006 11.6048 14.0003 10.764 14 10.0611V10.0611L14 10C14 9.2148 14.0091 8.58557 14.2069 8.14057C14.2961 7.93979 14.4186 7.79298 14.5957 7.6897C14.7792 7.58264 15.0602 7.5 15.5 7.5C15.7761 7.5 16 7.27614 16 7C16 6.72386 15.7761 6.5 15.5 6.5C15.0602 6.5 14.7792 6.41736 14.5957 6.3103C14.4186 6.20702 14.2961 6.06021 14.2069 5.85943C14.0091 5.41443 14 4.78521 14 4L14 3.9389V3.9389C14.0003 3.23603 14.0006 2.39517 13.7069 1.73443C13.5461 1.37271 13.2936 1.05077 12.9082 0.825923C12.5292 0.604857 12.0602 0.5 11.5 0.5Z" fill="currentColor" /></svg>`,
      title: "Code",
    };
  }

  /**
   * Allow to use native Enter behaviour
   *
   * @public
   * @returns {boolean}
   */
  static get enableLineBreaks() {
    return true;
  }

  /**
   * Default placeholder for CodeMirrorTool`s codearea
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_CODE_AREA_PLACEHOLDER() {
    return "Enter some code";
  }

  /**
   * Default placeholder for languageSelect
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_LANGUAGE() {
    return "Python";
  }

  /**
   * Default placeholder for themeSelect
   *
   * @public
   * @returns {string}
   */
  static get DEFAULT_THEME() {
    return "Dark";
  }

  /**
   * Default language options
   *
   * @public
   * @returns {string[]}
   */
  static get DEFAULT_LANGUAGE_OPTIONS() {
    return Object.keys(SUPPORT_LANGUAGES);
  }

  /**
   * Default theme options
   *
   * @public
   * @returns {string[]}
   */
  static get DEFAULT_THEME_OPTIONS() {
    return Object.keys(THEMES);
  }

  /**
   * Styles
   *
   * @private
   */
  get CSS() {
    return {
      baseClass: this.api.styles.block,
      wrapper: "cdx-codemirror",
      input: this.api.styles.input,
      language: "cdx-codemirror__language",
      codearea: "cdx-codemirror__codearea",
      themeSelect: "cdx-codemirror__themeSelect",
      selectwrapper: `cdx-codemirror__selectwrapper__${this.data.theme}`,
    };
  }

  /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} options - tool constricting options
   * @param {CodeData} options.data — previously saved plugin code
   * @param {object} options.config - user config for Tool
   * @param {object} options.api - Editor.js API
   * @param {boolean} options.readOnly - read only mode flag
   */
  constructor({ data, config, api, readOnly }) {
    this.api = api;
    this.config = config;
    this.readOnly = readOnly;
    /**
     *
     * !! Before you using defaultLanguage and defaultTheme passed by config, they SHOULD BE in SUPPORT_LANGUAGES and THEMES !!
     */
    const recentLanguage = this.config.alwaysUseRecentLanguage ? localStorage.getItem(EDITOR_JS_CODE_BLOCK_RECENT_LANGUAGE) : null;
    const recentTheme = this.config.alwaysUseRecentTheme ? localStorage.getItem(EDITOR_JS_CODE_BLOCK_RECENT_THEME) : null;
    this.languageOptions = CodeMirrorTool.DEFAULT_LANGUAGE_OPTIONS;
    this.themeOptions = CodeMirrorTool.DEFAULT_THEME_OPTIONS;

    this.data = {
      language: data.language || recentLanguage || CodeMirrorTool.DEFAULT_LANGUAGE,
      code: data.code || "",
      theme: data.theme || recentTheme || CodeMirrorTool.DEFAULT_THEME,
    };
  }

  /**
   * Control keydown events which are occured in codeMirrorTool
   * Also control undoEvent if it was passed via constructor
   *
   * @private
   * @param {KeyboardEvent} e - key down event
   */
  onKeyDown(e) {
    switch (e.code) {
      case "Backspace":
        this.backspace(e);
        break;
      case "ArrowDown":
        this.arrowDown(e);
        break;
      case "ArrowUp":
        this.arrowUp(e);
        break;
      case "ArrowRight":
        this.arrowRight(e);
        break;
      case "ArrowLeft":
        this.arrowLeft(e);
        break;
      default:
        break;
    }
  }

  /**
   * Actual events when key down.
   *
   * @param {KeyboardEvent} e - key down event
   */
  backspace(e) {
    /** Prevents going previous block when backspace pressed, even contents is not blank. */
    e.stopPropagation();
    const value = this.codemirror.getValue();
    /** When there is no code, move to previous block */
    if (value === "") {
      this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex() - 1, "end");
    }
  }

  arrowDown(e) {
    e.stopPropagation();
    const doc = this.codemirror.getDoc();
    const { line } = doc.getCursor();
    if (doc.lineCount() === line + 1) {
      // If it is last line, go next block
      e.preventDefault();
      this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex() + 1, "start");
    }
  }

  arrowUp(e) {
    e.stopPropagation();
    const doc = this.codemirror.getDoc();
    const { line } = doc.getCursor();
    if (line === 0) {
      // If it is first line, go previous block
      e.preventDefault();
      this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex() - 1, "end");
    }
  }

  arrowRight(e) {
    e.stopPropagation();
    const doc = this.codemirror.getDoc();
    const { line, ch } = doc.getCursor();
    if (doc.lineCount() === line + 1) {
      const lineLength = doc.getLine(line).length;
      if (ch === lineLength) {
        // If cursor is in (lastLine, lastCh), go next block
        e.preventDefault();
        this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex() + 1, "start");
      }
    }
  }

  arrowLeft(e) {
    e.stopPropagation();
    const doc = this.codemirror.getDoc();
    const { line, ch } = doc.getCursor();
    // If cursor is in (0,0),go previous block
    if (line === 0 && ch === 0) {
      e.preventDefault();
      this.api.caret.setToBlock(this.api.blocks.getCurrentBlockIndex() - 1, "end");
    }
  }

  onKeyUp(cm, e) {
    const doc = cm.getDoc();
    const cursor = doc.getCursor();
    const token = cm.getTokenAt(cursor);
    if (!cm.state.completionActive && !EXCLUDED_INTELLI_SENSE_TRIGGER_KEYS[(e.keyCode || e.which).toString()] && this.checkForbidAutoCompleteConditions(token)) {
      CODE_MIRROR_EDITOR.commands.autocomplete(cm, null, { completeSingle: false });
    }
  }

  /**
   * Check triggers what should be excluded from autocomplete by token
   *
   * @param {Token} token- key down event
   */
  checkForbidAutoCompleteConditions(token) {
    return token.type !== "def" && token.string !== "{" && token.string !== "}" && token.string !== "(" && token.string !== ")";
  }

  setSelectedAttributeToOption(e) {
    e.target.childNodes.forEach((option) => {
      option.value === e.target.value ? option.setAttribute("selected", "") : option.removeAttribute("selected");
    });
  }

  /**
   * Make themeSelect element and return
   * @private
   * @return {HTMLElement}
   */
  getThemeSelect() {
    const themeSelect = makeElement("select", this.CSS.themeSelect);
    themeSelect.dataset.placeholder = this.data.theme;
    // Add option for themeSelect
    for (let themeOption in this.themeOptions) {
      let option = document.createElement("option");
      let v = document.createAttribute("value");
      let t = document.createTextNode(this.themeOptions[themeOption]);
      v.value = this.themeOptions[themeOption];
      option.appendChild(t);
      option.setAttributeNode(v);
      themeSelect.appendChild(option);
    } // Set onchange listener for themeSelect
    themeSelect.addEventListener("change", (e) => {
      this.data.theme = e.target.value;
      this.setSelectedAttributeToOption(e);
      localStorage.setItem(EDITOR_JS_CODE_BLOCK_RECENT_THEME, this.data.theme);
      this.selectwrapper.className = `cdx-codemirror__selectwrapper__${this.data.theme}`;
      this.codemirror.setOption("theme", this.data.theme === "Light" ? "eclipse" : "dracula"); // Set codemirror mode by selected theme
    });
    themeSelect.value = this.data.theme;

    return themeSelect;
  }

  /**
   * Make languageSelect element and return
   * @private
   * @return {HTMLElement}
   */

  getLangaugeSelect() {
    const languageSelect = makeElement("select", this.CSS.language);
    languageSelect.dataset.placeholder = this.data.language;
    // Add option for language
    const languageOptions = this.languageOptions;

    for (let f in languageOptions) {
      let option = document.createElement("option");
      let v = document.createAttribute("value");
      let t = document.createTextNode(languageOptions[f]);
      v.value = languageOptions[f];
      option.appendChild(t);
      option.setAttributeNode(v);
      languageSelect.appendChild(option);
    }
    languageSelect.value = this.data.language;
    languageSelect.onchange = (e) => {
      this.data.language = e.target.value;
      this.setSelectedAttributeToOption(e);
      localStorage.setItem(EDITOR_JS_CODE_BLOCK_RECENT_LANGUAGE, this.data.language);
      if (SUPPORT_LANGUAGES[e.target.value]) {
        this.codemirror.setOption("mode", SUPPORT_LANGUAGES[e.target.value].toLowerCase()); // Set codemirror mode by selected language
      }
    };

    return languageSelect;
  }

  /**
   * Make CodeMirror and set events
   * @private
   */
  setCodeMirror() {
    if (!this.readOnly) {
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    const codemirror = CODE_MIRROR_EDITOR.fromTextArea(this.codearea, {
      tabSize: 4,
      styleActiveLine: { nonEmpty: true },
      styleActiveSelected: true,
      lineNumbers: true,
      line: false,
      foldGutter: true,
      autofocus: false,
      styleSelectedText: true,
      mode: SUPPORT_LANGUAGES[this.data.language] ? SUPPORT_LANGUAGES[this.data.language].toLowerCase() : null,
      matchBrackets: true,
      showCursorWhenSelecting: true,
      theme: this.data.theme === "Light" ? "eclipse" : "dracula",
      autoCloseTags: true,
      dragDrop: true,
      lint: true,
      hintOptions: {
        completeSingle: false,
      },
      autoCloseBrackets: true,
      readOnly: this.readOnly ? "nocursor" : false,
    });
    codemirror.on("keyup", (cm, e) => {
      this.onKeyUp(cm, e);
    });
    codemirror.on("keydown", (cm, e) => {
      this.onKeyDown(e);
    });
    this.codemirror = codemirror;
  }

  /**
   * Return Tool's view
   *
   * @public
   * @returns {HTMLDivElement} container
   */
  render() {
    const container = makeElement("div", [this.CSS.wrapper, this.CSS.baseClass], {});
    // Set stopPropagation for using tab in code block
    this.container = container;
    container.addEventListener("keydown", (e) => {
      if (e.code === "Tab") e.stopPropagation();
    });
    const codearea = makeElement("textarea", [this.CSS.input], {
      contentEditable: true,
      innerHTML: this.data.code,
    });
    this.codearea = codearea;

    const selectwrapper = makeElement("div", [this.CSS.selectwrapper]);
    selectwrapper.appendChild(this.getLangaugeSelect());
    selectwrapper.appendChild(this.getThemeSelect());
    this.selectwrapper = selectwrapper;
    container.appendChild(selectwrapper);
    container.appendChild(codearea);

    this.setCodeMirror();

    // Focus to codemirror when it is made.
    setTimeout(async () => {
      this.codemirror.refresh();
    }, 50);
    // After create codemirror by codearea, delete codearea
    // because it causes one more time focus issue.
    container.removeChild(codearea);
    return container;
  }

  /**
   * onPaste callback fired from Editor`s core
   *
   * @param {PasteEvent} event - event with pasted content
   */
  onPaste(event) {
    const content = event.detail.data;
    this.data = {
      code: content.textContent,
    };
  }

  /**
   * Returns true to notify core that read-only is supported
   *
   * @returns {boolean}
   */
  static get isReadOnlySupported() {
    return true;
  }

  /**
   * Extract Tool's data from the view
   * @public
   * @returns {CodeMirrorToolData} - saved data
   */
  save() {
    return Object.assign(this.data, {
      code: this.codemirror.getValue(),
      language: this.data.language,
    });
  }

  /**
   * Sanitizer rules
   */
  static get sanitize() {
    return {
      language: {},
      code: true,
    };
  }

  /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {{tags: string[]}}
   */
  static get pasteConfig() {
    return {
      tags: ["pre"],
    };
  }

  static convertToPlainHTML(data) {
    return `<pre><code>${data.code}</code></pre>`;
  }
}
